(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hide-whatsapp-on-menu"] && !Shopify.designMode) return;
  try {
    (function() {
    var MENU_SUMMARY_SELECTOR = '#Details-menu-drawer-container > summary[aria-controls="menu-drawer"]';
    var WHATSAPP_SELECTOR = '.gty-wacb-wrapper';

    function updateWhatsappVisibility() {
      var summary = document.querySelector(MENU_SUMMARY_SELECTOR);
      var whatsapp = document.querySelector(WHATSAPP_SELECTOR);

      if (!summary || !whatsapp) return;

      var isExpanded = summary.getAttribute('aria-expanded') === 'true';
      whatsapp.style.display = isExpanded ? 'none' : '';
    }

    function onReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    onReady(function() {
      updateWhatsappVisibility();

      var summary = document.querySelector(MENU_SUMMARY_SELECTOR);
      if (!summary) return;

      summary.addEventListener('click', function() {
        window.requestAnimationFrame(updateWhatsappVisibility);
      });

      var details = document.getElementById('Details-menu-drawer-container');
      if (details) {
        details.addEventListener('toggle', updateWhatsappVisibility);
      }

      var observer = new MutationObserver(function(mutations) {
        var shouldUpdate = mutations.some(function(mutation) {
          return mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded';
        });
        if (shouldUpdate) updateWhatsappVisibility();
      });

      if (summary) {
        observer.observe(summary, { attributes: true, attributeFilter: ['aria-expanded'] });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-add-popdown"] && !Shopify.designMode) return;
  try {
    (function () {
    const popdown = document.querySelector('[data-product-add-popdown]');
    if (!popdown) return;

    const variantTitleEl = popdown.querySelector('[data-popdown-variant-title]');
    const cartCountEl = popdown.querySelector('[data-cart-count]');
    const cartCountTemplateEl = popdown.querySelector('[data-cart-count-template]');
    const closeButtons = popdown.querySelectorAll('[data-close-popdown]');
    const viewCartButton = popdown.querySelector('[data-open-cart-drawer]');

    // General flag to allow cart drawer to stay open when user intended it
    let allowDrawerOpen = false;
    let hideTimeoutId;

    function showPopdown() {
      window.clearTimeout(hideTimeoutId);
      popdown.hidden = false;
      popdown.classList.add('is-visible');
      hideTimeoutId = window.setTimeout(hidePopdown, 4000);
    }

    function hidePopdown() {
      popdown.classList.remove('is-visible');
      popdown.hidden = true;
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', hidePopdown);
    });

    // When user clicks "View cart" in the popdown, we ALLOW the drawer to open and stay open
    if (viewCartButton) {
      viewCartButton.addEventListener('click', function (event) {
        event.preventDefault();
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          allowDrawerOpen = true;
          drawer.classList.add('active');
          document.body.classList.add('overflow-hidden');
          hidePopdown();
          window.setTimeout(function () {
            allowDrawerOpen = false;
          }, 500);
        } else {
          window.location.href = '/cart';
        }
      });
    }

    function updateVariantTitleFromForm() {
      try {
        if (!variantTitleEl) return;

        const originalMethod = document.querySelector('[data-product-variant-title]');
        if (originalMethod && originalMethod.textContent.trim()) {
          variantTitleEl.textContent = originalMethod.textContent.trim();
          return;
        }

        const checkedOptions = document.querySelectorAll('variant-radios input[type="radio"]:checked, product-info fieldset input[type="radio"]:checked');
        if (checkedOptions.length > 0) {
          const variantNames = Array.from(checkedOptions).map(function(opt) { return opt.value; });
          variantTitleEl.textContent = variantNames.join(' | ');
          return;
        }

        const selectOptions = document.querySelectorAll('variant-selects select');
        if (selectOptions.length > 0) {
          const variantNames = Array.from(selectOptions).map(function(sel) { return sel.options[sel.selectedIndex].value; });
          variantTitleEl.textContent = variantNames.join(' | ');
          return;
        }

        variantTitleEl.textContent = '';
      } catch (error) {
        console.error('Popdown Variant Error:', error);
      }
    }

    function handleCartUpdated() {
      fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (cartCountEl && cartCountTemplateEl) {
            const template = cartCountTemplateEl.getAttribute('data-template') || '';
            cartCountEl.textContent = cart.item_count
              ? template.replace('[[count]]', cart.item_count)
              : '';
          }
          updateVariantTitleFromForm();
          showPopdown();
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // Hook into renderContents so we show the popdown on any cart update
    if (cartElement && typeof cartElement.renderContents === 'function') {
      const originalRenderContents = cartElement.renderContents.bind(cartElement);

      cartElement.renderContents = function () {
        originalRenderContents.apply(cartElement, arguments);

        try {
          handleCartUpdated();
        } catch (error) {
          console.error(error);
        }
      };
    } else {
      document.addEventListener('product:added', handleCartUpdated);
    }

    // Observe cart-drawer so it doesn't auto-open after add-to-cart,
    // but DO allow it to open when allowDrawerOpen is true (header icon or popdown)
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const observer = new MutationObserver(function (mutationsList) {
        for (var i = 0; i < mutationsList.length; i++) {
          var mutation = mutationsList[i];
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var classList = drawer.classList;
            if (classList.contains('active') && !allowDrawerOpen) {
              // Drawer opened automatically (add-to-cart, etc.) – close it.
              classList.remove('active');
              document.body.classList.remove('overflow-hidden');
            }
          }
        }
      });

      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    // NEW: When user clicks the header cart icon, allow the drawer to open and stay open
    const headerCartIcon = document.querySelector('#cart-icon-bubble');
    if (headerCartIcon) {
      headerCartIcon.addEventListener('click', function () {
        allowDrawerOpen = true;
        window.setTimeout(function () {
          allowDrawerOpen = false;
        }, 500);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
